module.exports = __webpack_public_path__ + "static/media/downArrow.a9411fe4.svg";